import { useEffect, useState } from 'react';
import axios from 'axios';
import { Link2, Link2Off } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const hourlyRate = (c) => {
  if (!c) return 0;
  if (c.default_rate_type === 'per_hour' && Number(c.default_rate_value) > 0) return Number(c.default_rate_value);
  const p = (c.rate_presets || []).find(x => x.type === 'per_hour' && Number(x.value) > 0);
  return p ? Number(p.value) : 0;
};

export const WorkOrderClientPicker = ({ order, setOrder, token, disabled, selectCls }) => {
  const [clients, setClients] = useState([]);

  useEffect(() => {
    axios.get(`${API_URL}/api/atelier-billing/clients`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setClients(r.data || [])).catch(() => setClients([]));
  }, [token]);

  const linked = clients.find(c => c.id === order.client_id);

  const pick = (id) => {
    const c = clients.find(x => x.id === id);
    if (!c) { setOrder(prev => ({ ...prev, client_id: '' })); return; }
    const addr = [c.address, [c.city, c.province, c.postal_code].filter(Boolean).join(' ')].filter(Boolean).join(', ');
    setOrder(prev => ({ ...prev, client_id: c.id, client_name: c.name, client_phone: c.phone || '', client_address: addr, client_email: c.email || '' }));
  };

  return (
    <div className="space-y-2">
      <select value={order.client_id || ''} onChange={e => pick(e.target.value)} className={selectCls} disabled={disabled} data-testid="client-select">
        <option value="">-- Client atelier (facturation) --</option>
        {clients.map(c => <option key={c.id} value={c.id}>{`${c.name}${c.phone ? ` (${c.phone})` : ''}`}</option>)}
      </select>
      {linked ? (
        <p className="text-[11px] text-emerald-400 flex items-center gap-1.5" data-testid="client-linked-badge">
          <Link2 size={12} /> Lié à la facturation · {hourlyRate(linked) ? `${hourlyRate(linked).toFixed(2)} $/h` : 'taux horaire manquant'}
          {linked.parts_markup_percent != null && linked.parts_markup_percent !== '' ? ` · majoration ${linked.parts_markup_percent} %` : ''}
        </p>
      ) : order.client_name ? (
        <p className="text-[11px] text-amber-400 flex items-center gap-1.5" data-testid="client-free-badge">
          <Link2Off size={12} /> Client ponctuel (nom libre) — l'admin complétera le tarif sur la facture
        </p>
      ) : null}
    </div>
  );
};
